export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11146.2e4d7f32.jpg";